import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../context/AuthContext";
import { ChildrenProps } from "../libs/Common";

export default function AuthenticatedRoute(props: any) {
  const { pathname, search } = useLocation();
  const { user } = useUser();
  const { children } = props;
  console.log(user);
  if (!user) {
    return <Navigate to={`/login?redirect=/`} />;
  }

  return children;
}
